import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.push.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { initDB } from '@/api/initdb';
export default {
  name: 'Init',
  data: function data() {
    return {
      form: {
        sqlType: 'mysql',
        host: '127.0.0.1',
        port: '3306',
        userName: 'root',
        password: '',
        dbName: 'gva'
      }
    };
  },
  methods: {
    onSubmit: function onSubmit() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var loading, res, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading = _this.$loading({
                lock: true,
                text: '正在初始化数据库，请稍候',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context.prev = 1;
              _context.next = 2;
              return initDB(_this.form);
            case 2:
              res = _context.sent;
              if (res.code === 0) {
                _this.$message({
                  type: 'success',
                  message: res.msg
                });
                _this.$router.push({
                  name: 'Login'
                });
              }
              loading.close();
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              loading.close();
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[1, 3]]);
      }))();
    }
  }
};